export const appDeepLinkHomeScreen = 'main'

export function appDeepLinkQuestion(questionUuid: string) {
    return `questions/${questionUuid}`
}

export function appDeepLinkKnow(knowUuid: string) {
    return `knows/${knowUuid}`
}
